'use es6';

import { createAction } from 'redux-actions';
import { INITIALIZE_STORE_DATA } from '../constants/actionTypes';
export const initializeStoreData = createAction(INITIALIZE_STORE_DATA, initialStoreData => Object.assign({}, initialStoreData, {
  omnibusData: initialStoreData.omnibusData || {}
}));